import GradeSectionList from './List'

export default function GradeSectionsListIndex() {
  return <GradeSectionList />
}
